import React, { useContext, useState } from "react";
import "./SupportModal.scss";
import Modal from "../Modal/Modal";
import { useTranslation } from "react-i18next";
import ApiContext from "../../Api/ApiContext";
import RestrictReadOnly from "../../Helpers/RestrictReadOnly";
import { useSelector } from "react-redux";
import { selectResellerConfig } from "../../Store/configSlice";

const SupportModal = (props) => {

    const { subject, feature, showModal, setShowModal } = props;

    const [ content, setContent ] = useState("");
    const [ issue, setIssue ] = useState("");
    const [ error, setError ] = useState(false);
    const [ loading, setLoading ] = useState(false);

    const api = useContext(ApiContext);
    const resellerConfig = useSelector(selectResellerConfig);

    const { t } = useTranslation();

    const [ sendSuccesful, setSendSuccesful ] = useState(false);

    const getFeedbackData = () => {
        const pathSegments = window.location.pathname.split('/').filter(Boolean);
        const id = pathSegments[1];

        if (resellerConfig) {   
            return {
                documentId: id,
                content
            }
        }

        return {
            documentId: id,
            subject: (issue !== "" ? `${issue} | ` : "") + subject,
            content,
            feature,
        }
    };

    const supportForm = () => {

        function sendTicket() {

            setSendSuccesful(false);

            if(loading) return;

            setLoading(true);

            api.post(
                "/feedback",
                getFeedbackData()
            ).then(res => {
                setLoading(false);
                if(!res.data)
                    setError(true);
                else {
                    setError(false);
                    setContent("");
                    setIssue("");
                    setSendSuccesful(true);
                }
            }).catch(err => {
                setLoading(false);
                setError(true);
            });
        }

        const SelectIssue = () => {

            return (
                <div className="options">
                    <div className={"option" + (issue === t('support.issue1') ? " selected" : "")} onClick={() => setIssue(t('support.issue1'))}>
                        <span>{t('support.issue1')}</span>
                    </div>
                    <div className={"option" + (issue === t('support.issue2') ? " selected" : "")} onClick={() => setIssue(t('support.issue2'))}>
                        <span>{t('support.issue2')}</span>
                    </div>
                    <div className={"option" + (issue === t('support.issue3') ? " selected" : "")} onClick={() => setIssue(t('support.issue3'))}>
                        <span>{t('support.issue3')}</span>
                    </div>
                </div>
            );
        }

        return (
            <div className="supportForm">
                {!process.env.REACT_APP_IS_RESELLER && <SelectIssue />}
                <textarea placeholder={process.env.REACT_APP_IS_RESELLER ? t('reseller.support.placeholder') : t('support.placeholder')} onChange={(e) => setContent(e.target.value)}></textarea>
                {process.env.REACT_APP_IS_RESELLER && <span className="info">{t('reseller.support.info')}</span>}
                <RestrictReadOnly>
                    <div className={"button" + (loading ? " loading" : "") + (content !== "" ? "" : " disabled")} onClick={sendTicket}>
                        {t('send')} {loading && <div className="loader"></div>}
                    </div>
                </RestrictReadOnly>
                {error && <span className="error">{t('support.error')}</span>}
                {sendSuccesful && <span className="success">{t('support.success')}</span>}
            </div>
        );
    };

    return (
        <div className="supportModal">
            <Modal showModal={showModal} setShowModal={setShowModal} title={process.env.REACT_APP_IS_RESELLER ? t('reseller.support.button') : t('support.title')} content={supportForm()} />
        </div>
    );
};

export default SupportModal;